// Geotab returns fuel as either a 0–1 ratio or 0–100 percentage.
// Normalize to a rounded integer 0–100.
export function normalizeFuelLevel(rawValue: number | null | undefined): number | null {
  if (rawValue === null || rawValue === undefined || isNaN(rawValue)) return null;
  let val = parseFloat(String(rawValue));
  if (val >= 0 && val <= 1) val = val * 100;
  return Math.round(Math.min(100, Math.max(0, val)));
}
